import React, {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import axiosInstance from "../http/axios";
import {Helmet} from "react-helmet-async";

const ValidateEmail = () => {

    const { t } = useTranslation();

    const [submited , setSubmited ] = useState(false)
    
    const lang = useSelector((state) => state.language);

    const [success, setSuccess] = useState(null)

    const [error, setError ] = useState(null);

    const navigate = useNavigate();

    const { token } = useParams();

    const application_type = process.env.REACT_APP_TYPE;

    const validate = async (e) => {

        if (submited == true) {
            return
        }

        setSubmited(true);

        try {
            await axiosInstance.post('/validate-account?lang=' + lang, {token}).then((response) => {
                if( response.data.success) {
                    setSuccess(true);
                    navigate('/' + lang + '/login');

                } else {
                    setSuccess(false);
                }
            }).catch((error) => {
                console.log("error on email validation : =" + error)
                setSuccess(false);
                setError(error)
            });
        } finally {
            setSubmited(true)
        }
    }   

    return (
        <>
            <Helmet>
                <title>{ application_type === 'b2b' ? 'Farming Weather' : 'Precision Weather Forecast'}</title>
            </Helmet>
            <div className="page">
                { success === null ? <button disabled={submited} className="btn btn-dark" onClick={e=> validate(e)}>{t('validate_email')}</button>
                    : <div className="alert alert-danger" role="alert">{t('error_validation')}</div> }
            </div>
        </>
    )
}
export default ValidateEmail;